module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"UnitOrSublotAllocationComponents\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/unit-or-sublot-allocation-components/unit-or-sublot-allocation-components.component.html
// module id = ./src/app/unit-or-sublot-allocation-components/unit-or-sublot-allocation-components.component.html
// module chunks = main